import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";
import { setKindredPoints } from "../auth/authSlice";

export const ordersApi = createApi({
  reducerPath: "ordersApi",
  tagTypes: ["OrdersApi"], // Define available tags
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    updateOrder: builder.mutation({
      query: (order) => ({
        url: `/sales/portal/submit-store-order`,
        method: "POST",
        body: order,
      }),
      invalidatesTags: ["OrdersApi"],
    }),
    cancelOrder: builder.mutation({
      query: (body) => ({
        url: `/sales/portal/cancel-store-order`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["OrdersApi"],
    }),
    getKindredPoints: builder.query({
      query: () => `/user/portal/get-kindred-points`,
      providesTags: ["OrdersApi"],
      // Quick Log impersonation (authSlice.startImpersonation) nulls
      // kindredPoints and sets userInfo to null, so the Navbar query
      // (skip: !userInfo) unsubscribes and resubscribes once the
      // impersonated employee's userInfo loads. With RTK Query's default
      // cache settings the resubscribe serves the viewer's STALE cached
      // balance and onQueryStarted (which dispatches setKindredPoints)
      // never fires — so state.auth.kindredPoints stays null and the
      // Balance page's currentBalance falls back to 0. Mirror the same
      // query in authServices (which already sets both): drop the cache
      // entry on unsubscribe and force a refetch on the re-subscription,
      // so the impersonated employee's balance is fetched with the
      // impersonation token. (thread 1a02afe14d4f34bd)
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setKindredPoints(data));
        } catch (err) {
          // Handle error if needed
        }
      },
    }),
  }),
});

export const {
  useUpdateOrderMutation,
  useCancelOrderMutation,
  useGetKindredPointsQuery,
} = ordersApi;
